// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable @typescript-eslint/naming-convention */
import { DocumentView } from './DocumentView';
import { MaintenanceView } from './MaintenanceView';
import { PageView } from './PageView';

export const Views = {
	DocumentView,
	MaintenanceView,
	PageView,
};
